import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";
import { oneOfOptions, optionSchema } from "./choiceCommon.js";

const configSchema = z.object({
  options: z.array(optionSchema).default([]),
  layout: z.enum(["vertical", "horizontal"]).default("vertical"),
});

export const radioField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "radio",
  label: "Radio buttons",
  category: "choice",
  icon: "CircleDot",
  configSchema,
  valueSchema: (config, isRequired) =>
    optionalUnlessRequired(oneOfOptions(config.options), isRequired),
  defaultConfig: { options: [], layout: "vertical" },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: {},
};
